import { z } from 'zod';

export const CampaignTypeV1 = {
  OTHER: 0,
  SHOP: 1,
  OFFER: 2,
} as const;

export const ZodCampaignTypeV1 = z.nativeEnum(CampaignTypeV1);

export type CampaignTypeV1 = z.infer<typeof ZodCampaignTypeV1>;
